import { Observable } from 'rxjs';
import { flatMap, map } from 'rxjs/operators';

export const formErrorPipe = (property) => (
  source: Observable<any>,
): Observable<string[]> => source.pipe(
  flatMap((error) => (error.message
    ? error.message.filter((message) => message.property === property)
    : [])),
  map((error) => Object.values((error as any).constraints)),
);
